import React, { Component, Fragment } from 'react';
import { Layout, Typography, Card, Row, Col, Form, Input, InputNumber, DatePicker, Button, Switch, Select, message, Spin, Tabs, Table, Statistic, Tag, Badge, Popconfirm, Descriptions } from 'antd';
import { ArrowLeftOutlined, EditOutlined, DeleteOutlined, SaveOutlined, CloseOutlined } from '@ant-design/icons';
import AdminPortalHeader from '../../components/common/admin_portal_header';
import { getCorporateDiscountById, updateCorporateDiscount, deleteCorporateDiscount, toggleCorporateDiscount, getCorporateDiscountUsageStats, getDiscountUsageLogs, getPlans } from '../../api/pets-api';
import moment from 'moment';

const { Paragraph, Title } = Typography;
const { Content } = Layout;
const { TextArea } = Input;
const { Option } = Select;
const { TabPane } = Tabs;

class AdminCorporateDiscountDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            discountId: '',
            discount: null,
            loading: false,
            isEditing: false,
            plans: [],
            plansLoading: false,
            stats: null,
            statsLoading: false,
            usageLogs: [],
            usageLogsLoading: false,
            usageLogsPagination: {
                current: 1,
                pageSize: 10,
                total: 0
            },
            activeTab: '1'
        };
        this.formRef = React.createRef();
    }

    componentDidMount() {
        
    }

    async componentWillMount() {
        var splittedPath = this.props.location.pathname.split('/');
        console.log('Path segments:', splittedPath);
        let id = splittedPath[splittedPath.length - 1];
        console.log('Extracted discount ID:', id);
        
        if (id && id !== 'create') {
            this.setState({ discountId: id });
            this.fetchDiscountDetails(id);
            this.fetchPlans();
        }
    }

    fetchDiscountDetails = async (id) => {
        this.setState({ loading: true });
        try {
            console.log('Fetching discount details for ID:', id);
            const response = await getCorporateDiscountById(id);
            console.log('Discount details response:', response);
            
            if (response.status === 200 && response.data.status === 'ok') {
                this.setState({
                    discount: response.data.data,
                    loading: false
                });
            } else {
                message.error(response.data.message || 'Failed to load discount details');
                this.setState({ loading: false });
            }
        } catch (error) {
            console.error('Error fetching discount details:', error);
            message.error(error.response?.data?.message || 'Error loading discount details');
            this.setState({ loading: false });
        }
    };

    fetchPlans = async () => {
        this.setState({ plansLoading: true });
        try {
            const response = await getPlans();
            if (response.status === 200) {
                this.setState({ 
                    plans: response.data.result || [],
                    plansLoading: false 
                });
            }
        } catch (error) {
            console.error('Error fetching plans:', error);
            this.setState({ plansLoading: false });
        }
    };

    fetchUsageStats = async (id) => {
        this.setState({ statsLoading: true });
        try {
            console.log('Fetching usage stats for ID:', id);
            const response = await getCorporateDiscountUsageStats(id);
            console.log('Usage stats response:', response);
            
            if (response.status === 200 && response.data.status === 'ok') {
                this.setState({
                    stats: response.data.data,
                    statsLoading: false
                });
            } else {
                message.warning('No statistics available yet');
                this.setState({ 
                    stats: null,
                    statsLoading: false 
                });
            }
        } catch (error) {
            console.error('Error fetching stats:', error);
            message.warning('Could not load statistics');
            this.setState({ 
                stats: null,
                statsLoading: false 
            });
        }
    };

    fetchUsageLogs = async (page = 1, pageSize = 10) => {
        const { discountId } = this.state;
        this.setState({ usageLogsLoading: true });
        
        try {
            console.log('Fetching usage logs for discount ID:', discountId, 'page:', page);
            const response = await getDiscountUsageLogs({
                discountId: discountId,
                page,
                pageSize
            });
            console.log('Usage logs response:', response);
            
            if (response.status === 200 && response.data.status === 'ok') {
                const { logs, pagination } = response.data.data;
                
                this.setState({
                    usageLogs: logs || [],
                    usageLogsPagination: {
                        current: pagination?.currentPage || page,
                        pageSize: pagination?.pageSize || pageSize,
                        total: pagination?.totalItems || 0
                    },
                    usageLogsLoading: false
                });
            } else {
                this.setState({ 
                    usageLogs: [],
                    usageLogsLoading: false 
                });
            }
        } catch (error) {
            console.error('Error fetching usage logs:', error);
            this.setState({ 
                usageLogs: [],
                usageLogsLoading: false 
            });
        }
    };

    handleTabChange = (key) => {
        this.setState({ activeTab: key });
        
        const { discountId } = this.state;
        
        if (key === '2' && !this.state.stats) {
            this.fetchUsageStats(discountId);
        } else if (key === '3' && this.state.usageLogs.length === 0) {
            this.fetchUsageLogs();
        }
    };

    handleEdit = () => {
        this.setState({ isEditing: true });
    };

    handleCancelEdit = () => {
        this.setState({ isEditing: false });
        this.formRef.current?.resetFields();
    };

    handleSubmit = async (values) => {
        const { discountId } = this.state;
        this.setState({ loading: true });
        
        try {
            const data = {
                companyName: values.companyName,
                emailPattern: values.emailPattern,
                discountPercentage: values.discountPercentage,
                startDate: values.startDate.format('YYYY-MM-DD'),
                endDate: values.endDate ? values.endDate.format('YYYY-MM-DD') : null,
                isActive: values.isActive,
                description: values.description || null,
                contactPerson: values.contactPerson || null,
                contactEmail: values.contactEmail || null,
                contactPhone: values.contactPhone || null,
                maxUsageCount: values.maxUsageCount || null,
                appliedToPlanIds: values.appliedToPlanIds || []
            };

            const response = await updateCorporateDiscount(discountId, data);
            
            if (response.status === 200 && response.data.status === 'ok') {
                message.success('Corporate discount updated successfully');
                this.setState({ isEditing: false });
                this.fetchDiscountDetails(discountId);
            } else {
                message.error(response.data.message || 'Failed to update discount');
                this.setState({ loading: false });
            }
        } catch (error) {
            console.error('Error updating discount:', error);
            message.error(error.response?.data?.message || 'Error updating corporate discount');
            this.setState({ loading: false });
        }
    };

    handleToggleStatus = async () => {
        const { discountId } = this.state;
        try {
            const response = await toggleCorporateDiscount(discountId);
            if (response.status === 200 && response.data.status === 'ok') {
                message.success(response.data.message);
                this.fetchDiscountDetails(discountId);
            } else {
                message.error('Failed to toggle status');
            }
        } catch (error) {
            console.error('Error toggling status:', error);
            message.error('Error toggling discount status');
        }
    };

    handleDelete = async () => {
        const { discountId } = this.state;
        try {
            const response = await deleteCorporateDiscount(discountId);
            if (response.status === 200 && response.data.status === 'ok') {
                message.success('Corporate discount deleted successfully');
                this.props.history.push('/admin_corporate_discounts');
            } else {
                message.error('Failed to delete discount');
            }
        } catch (error) {
            console.error('Error deleting discount:', error);
            message.error('Error deleting corporate discount');
        }
    };

    handleBack = () => {
        this.props.history.push('/admin_corporate_discounts');
    };

    validateEmailPattern = (_, value) => {
        if (!value) {
            return Promise.reject(new Error('Please enter email pattern'));
        }
        
        const emailPatternRegex = /^[a-zA-Z0-9@._*-]+$/;
        if (!emailPatternRegex.test(value)) {
            return Promise.reject(new Error('Invalid email pattern format'));
        }
        
        return Promise.resolve();
    };

    disabledEndDate = (current) => {
        const startDate = this.formRef.current?.getFieldValue('startDate');
        if (!startDate) {
            return false;
        }
        return current && current <= startDate.startOf('day');
    };

    handleUsageLogsTableChange = (pagination) => {
        this.fetchUsageLogs(pagination.current, pagination.pageSize);
    };

    renderDetailsTab = () => {
        const { discount, isEditing, loading, plans, plansLoading } = this.state;

        if (!discount) return null;

        if (isEditing) {
            return (
                <Spin spinning={loading}>
                    <Form
                        ref={this.formRef}
                        layout="vertical"
                        onFinish={this.handleSubmit}
                        initialValues={{
                            companyName: discount.companyName,
                            emailPattern: discount.emailPattern,
                            discountPercentage: discount.discountPercentage,
                            startDate: moment(discount.startDate),
                            endDate: discount.endDate ? moment(discount.endDate) : null,
                            isActive: discount.isActive,
                            description: discount.description,
                            contactPerson: discount.contactPerson,
                            contactEmail: discount.contactEmail,
                            contactPhone: discount.contactPhone,
                            maxUsageCount: discount.maxUsageCount,
                            appliedToPlanIds: discount.appliedToPlanIds || []
                        }}
                    >
                        <Row gutter={[15, 15]}>
                            <Col xs={24} md={12}>
                                <Form.Item
                                    name="companyName"
                                    label="Company Name"
                                    rules={[{ required: true, message: 'Please enter company name' }]}
                                >
                                    <Input placeholder="Enter company name" size="large" />
                                </Form.Item>
                            </Col>

                            <Col xs={24} md={12}>
                                <Form.Item
                                    name="emailPattern"
                                    label="Email Pattern"
                                    rules={[
                                        { required: true, message: 'Please enter email pattern' },
                                        { validator: this.validateEmailPattern }
                                    ]}
                                >
                                    <Input placeholder="Enter email pattern" size="large" />
                                </Form.Item>
                            </Col>

                            <Col xs={24} md={12}>
                                <Form.Item
                                    name="startDate"
                                    label="Start Date"
                                    rules={[{ required: true, message: 'Please select start date' }]}
                                >
                                    <DatePicker 
                                        size="large" 
                                        style={{ width: '100%' }}
                                        format="DD/MM/YYYY"
                                    />
                                </Form.Item>
                            </Col>

                            <Col xs={24} md={12}>
                                <Form.Item
                                    name="endDate"
                                    label="End Date (Optional)"
                                >
                                    <DatePicker 
                                        size="large" 
                                        style={{ width: '100%' }}
                                        format="DD/MM/YYYY"
                                        disabledDate={this.disabledEndDate}
                                    />
                                </Form.Item>
                            </Col>

                            <Col xs={24} md={8}>
                                <Form.Item
                                    name="discountPercentage"
                                    label="Discount Percentage"
                                    rules={[
                                        { required: true, message: 'Please enter discount percentage' },
                                        { 
                                            validator: (_, value) => {
                                                if (value === null || value === undefined || value === '') {
                                                    return Promise.resolve();
                                                }
                                                if (value >= 0.01 && value <= 100) {
                                                    return Promise.resolve();
                                                }
                                                return Promise.reject(new Error('Must be between 0.01 and 100'));
                                            }
                                        }
                                    ]}
                                >
                                    <InputNumber
                                        placeholder="Enter discount %"
                                        size="large"
                                        style={{ width: '100%' }}
                                        min={0.01}
                                        max={100}
                                        step={0.01}
                                        precision={2}
                                    />
                                </Form.Item>
                            </Col>

                            <Col xs={24} md={8}>
                                <Form.Item
                                    name="maxUsageCount"
                                    label="Maximum Usage Count (Optional)"
                                >
                                    <InputNumber
                                        placeholder="Enter max usage count"
                                        size="large"
                                        style={{ width: '100%' }}
                                        min={1}
                                    />
                                </Form.Item>
                            </Col>

                            <Col xs={24} md={8}>
                                <Form.Item
                                    name="appliedToPlanIds"
                                    label="Apply to Plans (Optional)"
                                >
                                    <Select
                                        mode="multiple"
                                        placeholder="Select plans"
                                        size="large"
                                        loading={plansLoading}
                                    >
                                        {plans.map(plan => (
                                            <Option key={plan.id} value={plan.id}>
                                                {plan.title}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col xs={24}>
                                <Form.Item
                                    name="description"
                                    label="Description (Optional)"
                                >
                                    <TextArea 
                                        rows={4} 
                                        placeholder="Enter discount description"
                                        size="large"
                                    />
                                </Form.Item>
                            </Col>

                            <Col xs={24}>
                                <Title level={5}>Contact Information</Title>
                            </Col>

                            <Col xs={24} md={8}>
                                <Form.Item
                                    name="contactPerson"
                                    label="Contact Person"
                                >
                                    <Input placeholder="Enter contact person name" size="large" />
                                </Form.Item>
                            </Col>

                            <Col xs={24} md={8}>
                                <Form.Item
                                    name="contactEmail"
                                    label="Contact Email"
                                    rules={[{ type: 'email', message: 'Please enter a valid email' }]}
                                >
                                    <Input placeholder="Enter contact email" size="large" />
                                </Form.Item>
                            </Col>

                            <Col xs={24} md={8}>
                                <Form.Item
                                    name="contactPhone"
                                    label="Contact Phone"
                                >
                                    <Input placeholder="Enter contact phone" size="large" />
                                </Form.Item>
                            </Col>

                            <Col xs={24}>
                                <Form.Item
                                    name="isActive"
                                    label="Status"
                                    valuePropName="checked"
                                >
                                    <Switch 
                                        checkedChildren="Active" 
                                        unCheckedChildren="Inactive"
                                    />
                                </Form.Item>
                            </Col>

                            <Col xs={24}>
                                <Form.Item>
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        size="large"
                                        icon={<SaveOutlined />}
                                        loading={loading}
                                        style={{ marginRight: 10 }}
                                    >
                                        Save Changes
                                    </Button>
                                    <Button
                                        size="large"
                                        icon={<CloseOutlined />}
                                        onClick={this.handleCancelEdit}
                                    >
                                        Cancel
                                    </Button>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Spin>
            );
        }

        // View mode
        const planNames = discount.appliedToPlanIds && discount.appliedToPlanIds.length > 0
            ? plans.filter(p => discount.appliedToPlanIds.includes(p.id)).map(p => p.title).join(', ')
            : 'All Plans';

        return (
            <Fragment>
                <Descriptions bordered column={{ xxl: 2, xl: 2, lg: 2, md: 1, sm: 1, xs: 1 }}>
                    <Descriptions.Item label="Company Name">{discount.companyName}</Descriptions.Item>
                    <Descriptions.Item label="Email Pattern">
                        <Tag color="blue">{discount.emailPattern}</Tag>
                    </Descriptions.Item>
                    <Descriptions.Item label="Discount Percentage">
                        <Tag color="green" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                            {discount.discountPercentage}%
                        </Tag>
                    </Descriptions.Item>
                    <Descriptions.Item label="Status">
                        <Badge 
                            status={discount.isActive ? "success" : "default"} 
                            text={discount.isActive ? "Active" : "Inactive"} 
                        />
                    </Descriptions.Item>
                    <Descriptions.Item label="Start Date">
                        {moment(discount.startDate).format('DD MMM YYYY')}
                    </Descriptions.Item>
                    <Descriptions.Item label="End Date">
                        {discount.endDate ? moment(discount.endDate).format('DD MMM YYYY') : 'No End Date'}
                    </Descriptions.Item>
                    <Descriptions.Item label="Current Usage">
                        {discount.currentUsageCount || 0}
                    </Descriptions.Item>
                    <Descriptions.Item label="Maximum Usage">
                        {discount.maxUsageCount || 'Unlimited'}
                    </Descriptions.Item>
                    <Descriptions.Item label="Applied to Plans" span={2}>
                        {planNames}
                    </Descriptions.Item>
                    {discount.description && (
                        <Descriptions.Item label="Description" span={2}>
                            {discount.description}
                        </Descriptions.Item>
                    )}
                    {discount.contactPerson && (
                        <Descriptions.Item label="Contact Person">
                            {discount.contactPerson}
                        </Descriptions.Item>
                    )}
                    {discount.contactEmail && (
                        <Descriptions.Item label="Contact Email">
                            {discount.contactEmail}
                        </Descriptions.Item>
                    )}
                    {discount.contactPhone && (
                        <Descriptions.Item label="Contact Phone">
                            {discount.contactPhone}
                        </Descriptions.Item>
                    )}
                    <Descriptions.Item label="Created At">
                        {moment(discount.createdAt).format('DD MMM YYYY HH:mm')}
                    </Descriptions.Item>
                    <Descriptions.Item label="Last Updated">
                        {moment(discount.updatedAt).format('DD MMM YYYY HH:mm')}
                    </Descriptions.Item>
                </Descriptions>

                <Row gutter={[15, 15]} style={{ marginTop: 20 }}>
                    <Col>
                        <Button
                            type="primary"
                            icon={<EditOutlined />}
                            onClick={this.handleEdit}
                            size="large"
                        >
                            Edit Details
                        </Button>
                    </Col>
                    <Col>
                        <Popconfirm
                            title={`Are you sure you want to ${discount.isActive ? 'deactivate' : 'activate'} this discount?`}
                            onConfirm={this.handleToggleStatus}
                            okText="Yes"
                            cancelText="No"
                        >
                            <Button size="large">
                                {discount.isActive ? 'Deactivate' : 'Activate'}
                            </Button>
                        </Popconfirm>
                    </Col>
                    <Col>
                        <Popconfirm
                            title="Are you sure you want to delete this discount? This action cannot be undone."
                            onConfirm={this.handleDelete}
                            okText="Yes"
                            cancelText="No"
                        >
                            <Button danger icon={<DeleteOutlined />} size="large">
                                Delete
                            </Button>
                        </Popconfirm>
                    </Col>
                </Row>
            </Fragment>
        );
    };

    renderStatsTab = () => {
        const { stats, statsLoading } = this.state;

        if (statsLoading) {
            return <Spin size="large" style={{ display: 'block', margin: '50px auto' }} />;
        }

        if (!stats) {
            return <Paragraph>No statistics available</Paragraph>;
        }

        return (
            <Fragment>
                <Row gutter={[15, 15]}>
                    <Col xs={24} sm={12} md={6}>
                        <Card>
                            <Statistic 
                                title="Total Usage" 
                                value={stats.totalUsage || 0} 
                                valueStyle={{ color: '#3f8600' }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} sm={12} md={6}>
                        <Card>
                            <Statistic 
                                title="Total Policies" 
                                value={stats.totalPolicies || 0} 
                                valueStyle={{ color: '#1890ff' }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} sm={12} md={6}>
                        <Card>
                            <Statistic 
                                title="Total Discount Amount" 
                                value={stats.totalDiscountAmount || 0} 
                                prefix="AED "
                                precision={2}
                                valueStyle={{ color: '#cf1322' }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} sm={12} md={6}>
                        <Card>
                            <Statistic 
                                title="Avg Discount per Policy" 
                                value={stats.averageDiscountPerPolicy || 0} 
                                prefix="AED "
                                precision={2}
                            />
                        </Card>
                    </Col>
                </Row>

                {stats.usageByMonth && stats.usageByMonth.length > 0 && (
                    <Card title="Usage by Month" style={{ marginTop: 20 }}>
                        <Table
                            dataSource={stats.usageByMonth}
                            rowKey="month"
                            pagination={false}
                            columns={[
                                { title: 'Month', dataIndex: 'month', key: 'month' },
                                { title: 'Count', dataIndex: 'count', key: 'count' },
                                { 
                                    title: 'Total Discount', 
                                    dataIndex: 'totalDiscount', 
                                    key: 'totalDiscount',
                                    render: (value) => `AED ${value?.toFixed(2) || 0}`
                                }
                            ]}
                        />
                    </Card>
                )}
            </Fragment>
        );
    };

    renderUsageLogsTab = () => {
        const { usageLogs, usageLogsLoading, usageLogsPagination } = this.state;

        const columns = [
            {
                title: 'Date',
                dataIndex: 'usedAt',
                key: 'usedAt',
                render: (date) => moment(date).format('DD MMM YYYY HH:mm')
            },
            {
                title: 'User Email',
                dataIndex: 'userEmail',
                key: 'userEmail'
            },
            {
                title: 'Policy Number',
                dataIndex: 'policyNumber',
                key: 'policyNumber',
                render: (text) => text || 'N/A'
            },
            {
                title: 'Discount Applied',
                dataIndex: 'discountApplied',
                key: 'discountApplied',
                render: (value) => `${value}%`
            },
            {
                title: 'Original Amount',
                dataIndex: 'originalAmount',
                key: 'originalAmount',
                render: (value) => `AED ${value?.toFixed(2) || 0}`
            },
            {
                title: 'Discount Amount',
                dataIndex: 'discountAmount',
                key: 'discountAmount',
                render: (value) => `AED ${value?.toFixed(2) || 0}`
            },
            {
                title: 'Final Amount',
                dataIndex: 'finalAmount',
                key: 'finalAmount',
                render: (value) => `AED ${value?.toFixed(2) || 0}`
            }
        ];

        return (
            <Table
                columns={columns}
                dataSource={usageLogs}
                loading={usageLogsLoading}
                rowKey="id"
                pagination={usageLogsPagination}
                onChange={this.handleUsageLogsTableChange}
                scroll={{ x: 1000 }}
            />
        );
    };

    render() {
        const { discount, loading, activeTab } = this.state;

        if (loading && !discount) {
            return (
                <Layout className="main-layout dashboard-layout">
                    <AdminPortalHeader />
                    <Content className="dashboard-content">
                        <div className="container-fluid">
                            <Spin size="large" style={{ display: 'block', margin: '100px auto' }} />
                        </div>
                    </Content>
                </Layout>
            );
        }

        if (!discount) {
            return (
                <Layout className="main-layout dashboard-layout">
                    <AdminPortalHeader />
                    <Content className="dashboard-content">
                        <div className="container-fluid">
                            <Card>
                                <Paragraph>Discount not found</Paragraph>
                                <Button onClick={this.handleBack}>Back to Discounts</Button>
                            </Card>
                        </div>
                    </Content>
                </Layout>
            );
        }

        return (
            <Fragment>
                <Layout className="main-layout dashboard-layout">
                    <AdminPortalHeader />
                    <Content className="dashboard-content">
                        <div className="container-fluid">
                            <Row gutter={[15, 15]} className="mb-4">
                                <Col xs={24}>
                                    <Card>
                                        <Button
                                            type="link"
                                            icon={<ArrowLeftOutlined />}
                                            onClick={this.handleBack}
                                            style={{ padding: 0, marginBottom: 10 }}
                                        >
                                            Back to Discounts
                                        </Button>
                                        <Title level={3} className="mb-0">
                                            {discount.companyName}
                                        </Title>
                                        <Paragraph className="text-muted mb-0">
                                            Corporate Discount Details
                                        </Paragraph>
                                    </Card>
                                </Col>
                            </Row>

                            <Row gutter={[15, 15]}>
                                <Col xs={24}>
                                    <Card>
                                        <Tabs activeKey={activeTab} onChange={this.handleTabChange}>
                                            <TabPane tab="Details" key="1">
                                                {this.renderDetailsTab()}
                                            </TabPane>
                                            <TabPane tab="Statistics" key="2">
                                                {this.renderStatsTab()}
                                            </TabPane>
                                            <TabPane tab="Usage Logs" key="3">
                                                {this.renderUsageLogsTab()}
                                            </TabPane>
                                        </Tabs>
                                    </Card>
                                </Col>
                            </Row>
                        </div>
                    </Content>
                </Layout>
            </Fragment>
        );
    }
}

export default AdminCorporateDiscountDetails;
